import React from 'react'
import Card from '../Card'
import FamilyMemberLabel from '../FamilyMemberLabel'
import NotInsuredLabel from '../NotInsuredLabel'

import './EditableItem.css'

const EditableItem = ({
  disableEdit,
  children,
  onEdit,
  membersIds = [],
  showHeader = true,
  className = '',
  dataName = '',
  hideParticipents,
  title,
  ...others
}) => {
  const getRelatedMembers = () => {
    return membersIds.map(memberId => (
      <FamilyMemberLabel
        className="editable-item-participants"
        key={memberId}
        patientId={memberId}
      />
    ))
  }

  const getNotInsuredMembers = () => {
    return membersIds.map(memberId => (
      <NotInsuredLabel
        className="editable-item-participants"
        key={memberId}
        patientId={memberId}
      />
    ))
  }

  return (
    <Card className={'editable-item ' + className} {...others}>
      {showHeader && (
        <div className="editable-item-participants-container">
          {!hideParticipents && (
            <div className="editable-item-participants">
              {getNotInsuredMembers()}
              {getRelatedMembers()}
            </div>
          )}
          {title && <div className="editable-item-title">{title}</div>}
          <div
            className="editable-item-edit-button trackable"
            onClick={onEdit}
            data-hidden={disableEdit}
            data-name={dataName}
          >
            <i className="icon-edit" />
          </div>
        </div>
      )}
      <div className="editable-item-content">{children}</div>
    </Card>
  )
}

export default EditableItem
